import QRCode from "qrcode";

export default function useQRCode(): {
  generateQRCode: (text: string) => Promise<any>;
  // eslint-disable-next-line indent
} {
  const generateQRCode = async (text: string): Promise<any> => QRCode.toDataURL(text);

  return { generateQRCode };
}
